import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Module, Stack } from "types/generated";
import { hasAtLeastReadAccess } from "utils/access";

const useHasEntityReadAccess = (): ((
  entity?: Partial<Pick<Stack | Module, "canWrite" | "spaceDetails" | "space">>
) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (entity?: Partial<Pick<Stack | Module, "canWrite" | "spaceDetails" | "space">>) => {
      if (!entity) {
        return false;
      }

      if (viewer.admin) {
        return true;
      }

      if (entity.canWrite) {
        return true;
      }

      return hasAtLeastReadAccess(viewer, entity.spaceDetails?.id || entity.space);
    },
    [viewer]
  );
};

export default useHasEntityReadAccess;
